import { PRACTICE_MODE_WELCOME_VIDEO } from 'my-core/online-course-utils';

import { MultiColumnContentsWrapper } from 'my-components/OnlineCourse';
import Player from 'my-components/VideoPlayer';

import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import { faList } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const rootCss = ({ spacing }) => ({
  '.PMW-videoWrapper': {
    borderRadius: 8,
    overflow: 'hidden',
  },
  '.PMW-paper': { padding: spacing(2) },
  '.PMW-title': {
    marginBottom: spacing(2),
  },
});

export default function OnlineCoursePracticeModeWelcome({ onlineCourse }) {
  return (
    <MultiColumnContentsWrapper css={rootCss}>
      <div>
        <Player
          // autoPlay
          className="PMW-videoWrapper"
          {...PRACTICE_MODE_WELCOME_VIDEO}
        />
      </div>
      <div>
        <Paper className="PMW-paper" variant="outlined">
          <Typography align="center" className="PMW-title" color="primary" variant="h5">
            Welcome to {onlineCourse.course_code} Practice Mode
          </Typography>
          <Typography>Here’s how to get the most out of Practice Mode:</Typography>
          <ul>
            <li>
              <Typography>
                Use the table of contents ( <FontAwesomeIcon icon={faList} size="xs" /> ) on the left to focus on where
                you need help most.
              </Typography>
            </li>
            <li>
              <Typography>Make sure to attempt each question before you check the solution.</Typography>
            </li>
            <li>
              <Typography>Swap out a question for a new one at any point.</Typography>
            </li>
            <li>
              <Typography>Use the “Ask a question” feature below each question any time.</Typography>
            </li>
          </ul>
          <Typography>Good luck!</Typography>
        </Paper>
      </div>
    </MultiColumnContentsWrapper>
  );
}
